<mat-sidenav-container hasBackdrop="true" class="mx-auto p-0 -mt-px flex-auto border-t pt-0 sm:pt-0">
    <div class="mx-auto flex w-full flex-wrap p-4">
        <div class="flex flex-col sm:flex-row w-full mb-4 items-center justify-between">
            <div>
                <div class="flex items-center gap-1">
                    <div hoverMenu hoverDelay="50" #hoverDirective="hoverMenu" [matMenuTriggerFor]="infoMenu">
                        <button mat-icon-button color="primary">
                        <mat-icon svgIcon="heroicons_outline:exclamation-circle"></mat-icon>
                        </button>
                    </div>
                    <mat-menu [hasBackdrop]="false" [overlapTrigger]="false" class="w-full" #infoMenu="matMenu">
                        <div class="p-4">
                        <p>
                            Reporte de cambios de producto. Filtra por estado (aprobado, 
                            rechazado, pendiente) y exporta resultados. 
                            Úsalo para verificar que lo entregado coincida 
                            con lo autorizado.
                        </p>
                        </div>
                    </mat-menu>
                    <h2 class="text-xl font-semibold leading-8 tracking-tight">
                        De Cambios
                    </h2>
                </div>
                <div class="text-sm text-secondary font-medium tracking-tight">
                    Visualiza y exporta las solicitudes de <b>cambio de producto</b> de los <b>socios de negocio</b> por
                    <b>material</b>.
                </div>
            </div>
            <!-- Header -->
            <div class="relative flex flex-0 flex-col px-4 py-2 sm:flex-row sm:items-center sm:justify-between">
                <div class="flex shrink-0">
                    <!-- Title -->
                    <!--<div class="text-3xl font-extrabold tracking-tight">Pedidos</div> -->
                        <app-status-filters [selectedStatuses]="selectedStatuses" [selectedERPStatuses]="selectedERPStatuses"
                            [selectedCustomerType]="selectedCustomerType" [showStatus]="[1,0,6,7,8,14]"  [showERPStatus]="[0,1,2,3,4,5,6]"
                            [showCustomerType]="['BPT9002','BPT9001','BPT0001']" (selectionFilterApply)="getListReport()">
                        </app-status-filters>
                </div>
                <!-- Actions -->
                <div class="mt-6 flex shrink-0 items-center space-x-3 sm:ml-4 sm:mt-0">
                </div>
            </div>
        </div>
        <div
            class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl shadow xl:col-span-2 dark:bg-transparent">
            <!-- Main Content (Table and Paginator) -->
            <div class="pt-1 mx-6">
                <!-- Smart Grid -->
                <app-smart-grid
                    [data]="data"
                    [columnDefs]="columnDefs"
                    [config]="gridConfig"
                    [totalRecords]="totalItems"
                    [loading]="loading"
                    (pageChanged)="onPageChanged($event)"
                    (sortChanged)="onSortChanged($event)"
                    (searchChanged)="onSearchChanged($event)">
                </app-smart-grid>
            </div>
        </div>
    </div>

      <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
  
    <app-filter-section title="Rango de fechas" [expanded]="true">
      <app-dates-filters [form]="form" [showDateCreationRange]="true" [showStartTrip]="true"
        [showEndTrip]="true"></app-dates-filters>
    </app-filter-section>
  
    <app-filter-section title="Configuración" [expanded]="false" (onExpanded)="onConfigExpanded()">
      <app-configuration-filters [form]="form" [company]="true" [salesOffice]="true"
        [warehouse]="true" [loadData]="loadConfigData"></app-configuration-filters>
    </app-filter-section>
  
    <app-filter-section title="Documentos" [expanded]="false" (onExpanded)="onDocumentsExpanded()">
      <app-documents-filters [form]="form" [documentClass]="true" [typeDocumentClass]="type" [loadData]="loadDocumentsData"></app-documents-filters>
    </app-filter-section>
  
    <app-filter-section title="Gestión de rutas" [expanded]="false" (onExpanded)="onRoutesExpanded()">
      <app-routes-filters [form]="form" [route]="true" [loadData]="loadRoutesData"></app-routes-filters>
    </app-filter-section>
  
    <app-filter-section title="Socio de negocio" [expanded]="false" (onExpanded)="onBusinessPartnersExpanded()">
      <app-business-partners-filters [form]="form" [assignedUser]="true" [payingBusinessPartner]="true"
        [receivingBusinessPartner]="true" [loadData]="loadBusinessPartnersData"></app-business-partners-filters>
    </app-filter-section>
  
    <app-filter-section title="Gestión de Materiales" [expanded]="false" (onExpanded)="onMaterialsExpanded()">
      <app-materials-management-filters [form]="form" [materialGroup]="true" [material]="true" [isMultiple]="true"
      [loadData]="loadMaterialsData">
      </app-materials-management-filters>
    </app-filter-section>
     </app-filter>

    <!-- Filtros -->
    <!-- <app-filter (onFilterEvent)="onFilter()" (onCleanEvent)="onClearFilter()">
        <app-filter-section title="Rango de fechas" [expanded]="true">
            <mat-form-field class="w-full">
                <mat-label class="block text-gray-700">Desde/Hasta</mat-label>
                <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                    <input matStartDate formControlName="start" placeholder="Fecha Inicio">
                    <input matEndDate formControlName="end" placeholder="Fecha Fin">
                </mat-date-range-input>
                <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </app-filter-section>

        <app-filter-section title="Configuración" [expanded]="false">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label for="group-select" class="block text-gray-700">Almacenes</mat-label>
                <mat-select [(ngModel)]="filter.warehouseId" (selectionChange)="changeWarehouse($event.value)"
                    placeholder="Seleccione">
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchWarehouse" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="changueOptionsWarehouse($event)" placeholderLabel="Buscar..."
                            noEntriesFoundLabel="No se encontraron resultados">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let warehouse of warehouseFilterList" [value]="warehouse.id">
                        <span *ngIf="getCode(warehouse) as code ">{{code}} - </span>
                        {{ warehouse.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </app-filter-section>

        <app-filter-section title="Gestión de Rutas" [expanded]="false">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Rutas</mat-label>
                <mat-select name="subRouteId" [(ngModel)]="filter.routes" multiple>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchSubRoute" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="changueOptionsSubRoute($event)" placeholderLabel="Buscar..."
                            noEntriesFoundLabel="No se encontraron resultados">
                        </ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let function of listFilterSubRouteList" [value]="function.id">
                        <b *ngIf="getCode(function) as code ">{{code}} - </b> {{ function.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </app-filter-section>

        <app-filter-section title="Gestión de Materiales" [expanded]="false">
            <mat-form-field appearance="fill" class="w-full">
                <mat-label class="block text-gray-700">Material</mat-label>
                <mat-select [(ngModel)]="filter.item" name="item" multiple>
                    <mat-option>
                        <ngx-mat-select-search [(ngModel)]="searchMaterial" [ngModelOptions]="{standalone: true}"
                            (ngModelChange)="changueOptionsMaterial($event)" placeholderLabel="Buscar material..."
                            noEntriesFoundLabel="No se encontraron resultados">
                        </ngx-mat-select-search>
                    </mat-option>
                    @for (item of materialList; track item) {
                    <mat-option [value]="item.code">
                        <b>{{ item.code }}</b> - {{ item.name }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </app-filter-section>

        <app-filter-section title="Documentos" [expanded]="false">
            <mat-form-field appearance="fill" class="modal-input w-full">
                <mat-label class="block text-gray-700">Clase de Documento</mat-label>
                <mat-select [(ngModel)]="selectedDocumentClass" name="selectedDocumentClass" [multiple]="true"
                    placeholder="Seleccione Clase de Documento"
                    (selectionChange)="onDocumentClassSelectionChange($event.value)">
                    <mat-option>
                        <ngx-mat-select-search [formControl]="documentClassMultiFilterCtrl"
                            [showToggleAllCheckbox]="true"
                            [toggleAllCheckboxIndeterminate]="isIndeterminateDocumentClass"
                            [toggleAllCheckboxChecked]="isCheckedDocumentClass"
                            [noEntriesFoundLabel]="'No se encontraron resultados'"
                            [placeholderLabel]="'Buscar clase de documento...'"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let documentClass of filteredDocumentClasses | async"
                        [value]="documentClass.code">
                        {{ documentClass.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </app-filter-section>

        <app-filter-section title="Socios de Negocio" [expanded]="false">
            <mat-form-field appearance="fill" class="modal-input w-full">
                <mat-label class="block text-gray-700">Vendedor</mat-label>
                <mat-select [(ngModel)]="selectedSeller">
                    <mat-option [value]="'0'">Todos</mat-option>
                    <mat-option *ngFor="let seller of sellerList" [value]="seller.username">{{seller.username}} - {{
                        seller.first_name }} {{seller.last_name}}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill" class="modal-input w-full">
                <mat-label class="block text-gray-700">Pagador</mat-label>
                <input type="text" placeholder="Selecciona Pagador" aria-label="Selecciona pagador" matInput
                    [formControl]="soldToControl" [matAutocomplete]="autoSoldTo">
                <mat-autocomplete #autoSoldTo="matAutocomplete" [displayWith]="fetchSoldToName"
                    (optionSelected)="onChangeSoldTo()">
                    @for (soldTo of soldToList; track soldTo) {
                    <mat-option [value]="soldTo.id" class="text-content">
                        {{soldTo.name}}
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>

            <mat-form-field appearance="fill" class="modal-input w-full">
                <mat-label class="block text-gray-700">Receptor</mat-label>
                <input type="text" placeholder="Selecciona Receptor" aria-label="Selecciona Receptor" matInput
                    [formControl]="shipToControl" [matAutocomplete]="autoShipTo">
                <mat-autocomplete #autoShipTo="matAutocomplete" [displayWith]="fetchShipToName">
                    @for (shipTo of shipToList; track shipTo) {
                    <mat-option [value]="shipTo.id" class="text-content">
                        {{shipTo.name}}
                    </mat-option>
                    }
                </mat-autocomplete>
            </mat-form-field>
        </app-filter-section>
    </app-filter> -->
</mat-sidenav-container>